import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import React from 'react'

interface CameraControlsProps {
  url: string
  type: basic.CameraType
}

const CameraControls: React.FC<CameraControlsProps> = ({ url, type }) => {
  const { popup, openPopup } = usePopupState<{ type: 'camera', props: basic.CameraData }>()
  const { goBack } = useHistory()

  return (
    <div className='cam__wrapper__controls'>
      {popup?.type === 'camera'
        ? <i
          className='icon icon--fullscreen-exit cWhite'
          onClick={goBack}
        />
        : <i
          className='icon icon--fullscreen cWhite'
          onClick={() => {
            openPopup({
              type: 'camera',
              props: {
                ptz: -1,
                type,
                url
              }
            })
          }}
        />}
    </div>
  )
}

export default CameraControls